import React from 'react';

/*
import { useRef, useState, useEffect } from 'react';
import { Canvas, useFrame, useLoader } from '@react-three/fiber';
import { TextureLoader } from 'three';
import * as THREE from 'three';

function CarouselImage({ position, rotation, imageUrl, isActive, imageSize, index, angle, groupRotation }) {
  const meshRef = useRef();
  const [texture, setTexture] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [initialY] = useState(index % 2 === 0 ? 2 : -2);
  const [isEntering, setIsEntering] = useState(true);
  useEffect(() => {
    const loader = new TextureLoader();
    loader.load(imageUrl,(loadedTexture) => { setTexture(loadedTexture); setIsLoaded(true); },undefined,(error) => { console.error('Error loading texture:', error); });
  }, [imageUrl]);
  useFrame(() => {
    if (!meshRef.current || !isLoaded) return;
    meshRef.current.rotation.y = rotation;
    if (isEntering) {
      meshRef.current.position.y += (0 - meshRef.current.position.y) * 0.08;
      if (Math.abs(meshRef.current.position.y) < 0.01) { meshRef.current.position.y = 0; setIsEntering(false); }
    }
    meshRef.current.scale.set(1.0, 1.0, 1);
  });
  if (!isLoaded || !texture) { return null; }
  return (
    <mesh ref={meshRef} position={[position[0], initialY, position[2]]}>
      <planeGeometry args={imageSize} />
      <meshStandardMaterial map={texture} side={THREE.DoubleSide} transparent />
    </mesh>
  );
}

function RotatingCarousel({ images, radius, imageSize, onIndexChange }) {
  const groupRef = useRef();
  const [isHovered, setIsHovered] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const targetRotationRef = useRef(0);
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    if (groupRef.current && !isInitialized) { groupRef.current.rotation.y = 0; setIsInitialized(true); }
  }, [isInitialized]);
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        setCurrentIndex(prev => { const next = (prev + 1) % images.length; onIndexChange(next); return next; });
        const anglePerImage = (Math.PI * 2) / images.length;
        targetRotationRef.current -= anglePerImage;
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [images.length, isHovered, onIndexChange]);
  useFrame(() => {
    if (groupRef.current && isInitialized) {
      const diff = targetRotationRef.current - groupRef.current.rotation.y;
      groupRef.current.rotation.y += diff * 0.1;
    }
  });
  const imageCount = images.length;
  return (
    <group ref={groupRef} rotation={[0, 0, 0]} onPointerEnter={() => setIsHovered(true)} onPointerLeave={() => setIsHovered(false)}>
      {images.map((image, index) => {
        const angle = (index / imageCount) * Math.PI * 2;
        const x = Math.sin(angle) * radius;
        const z = Math.cos(angle) * radius;
        let rotationY;
        if (z > 0) { rotationY = angle; } else { rotationY = angle + Math.PI; }
        const isActive = index === currentIndex;
        return (<CarouselImage key={index} index={index} position={[x, 0, z]} rotation={rotationY} imageUrl={image.url} isActive={isActive} imageSize={imageSize} angle={angle} groupRotation={groupRef.current ? groupRef.current.rotation.y : 0} />);
      })}
    </group>
  );
}

function MobileSlider({ images, isTablet }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => { setCurrentIndex((prev) => (prev + 1) % images.length); setIsFading(false); }, 1500);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);
  return (
    <div className="w-full h-full flex items-center justify-center relative overflow-hidden mt-4 sm:mt-6 md:mt-8 mb-20 sm:mb-24 md:mb-28">
      {images.map((image, index) => (
        <div key={index} className={`absolute inset-0 flex flex-col items-center justify-center transition-opacity duration-[1500ms] ease-in-out ${index === currentIndex ? (isFading ? 'opacity-0' : 'opacity-100') : 'opacity-0'}`}>
          <img src={image.url} alt={`Slide ${index + 1}`} className={`object-contain ${isTablet ? 'w-[95vw] max-w-none h-auto max-h-[80vh]' : 'w-[95vw] max-w-none h-auto max-h-[80vh] px-2'}`} style={{ transform: 'rotate(0deg)' }} />
          <div className="mt-6 text-center px-4">
            <div className="text-[#D4A574] transition-all duration-500 ease-in-out" style={{ fontFamily: "'Poppins', sans-serif", fontSize: isTablet ? '1rem' : '0.875rem', fontWeight: '300', letterSpacing: '0.15em', textTransform: 'uppercase', textShadow: '0 2px 8px rgba(0,0,0,0.8)', WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale', lineHeight: '1.4' }}>
              {image.name}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}*/

export default function ImageCarousel({ onEnterSite }) {
  const [muted, setMuted] = React.useState(true);
  const [videoLoaded, setVideoLoaded] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 1024);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const videoSrc = isMobile
    ? '/animations/daat-coming-soon.mp4'
    : '/animations/landscape.mp4';

  return (
    <div className="w-full min-h-screen max-[500px]:min-h-[100dvh] bg-black flex flex-col items-center relative">
      {!videoLoaded && (
        <div className="absolute inset-0 w-full h-full flex items-center justify-center bg-black z-50">
          <div className="flex flex-col items-center">
            <img
              src="https://dev.daatglobal.com/email-assets/arch-biggest.gif"
              alt="Loading..."
              className="w-16 h-16 object-contain mb-3"
            />

            <div
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: '0.875rem',
                fontWeight: '300',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                color: '#D4A574',
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale'
              }}
            >
              Preparing Heritage
            </div>
          </div>
        </div>
      )}

      {/* VIDEO + ENTER SITE BUTTON */}
      <div className="relative w-fit flex flex-col items-center">

        <video
          key={videoSrc}
          autoPlay
          muted={muted}
          loop
          playsInline
          onCanPlayThrough={() => setVideoLoaded(true)}
          onContextMenu={(e) => e.preventDefault()}
          controlsList="nodownload"
          className="w-auto h-[88vh] max-[500px]:h-[88dvh] object-contain mx-auto block"
        >
          <source src={videoSrc} type="video/mp4" />
        </video>

        {videoLoaded && (
          <button
            onClick={() => {
              localStorage.setItem('daat_intro_seen', 'true');

              if (onEnterSite) {
                onEnterSite();
              }
            }}
            className="mt-4 px-8 py-3 text-xs sm:text-sm font-light text-white border border-white/80 rounded-full tracking-[0.2em] hover:text-[#A47F2D] hover:border-[#A47F2D] transition-all duration-300 hover:scale-105 lg:scale-75 lg:hover:scale-100 origin-center enter-site-button"
            style={{ fontFamily: "'Reforma-1918', serif" }}
          >
            ENTER SITE
          </button>
        )}

      </div>

      {/* MUTE BUTTON */}
      {videoLoaded && (
        <button
          onClick={() => setMuted(prev => !prev)}
          style={{
            fontFamily: "'Poppins', sans-serif",
            letterSpacing: '0.15em',
            fontSize: '0.7rem',
            fontWeight: '300',
            color: '#D4A574',
            border: '1px solid #D4A574',
            borderRadius: '9999px',
            padding: '6px 16px',
            background: 'rgba(0,0,0,0.5)',
            backdropFilter: 'blur(4px)',
            cursor: 'pointer',
            textTransform: 'uppercase',
            transition: 'all 0.3s ease'
          }}
          className="absolute top-6 right-6 z-50 hover:bg-[#D4A574] hover:text-black"
        >
          {muted ? '♪ Unmute' : '♪ Mute'}
        </button>
      )}

            {/* MOBILE SAFARI BUTTON FIX */}
      <style>{`
        @media screen and (max-width: 500px) {
          .enter-site-button {
            position: absolute;
            bottom: 18px;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 0;
            z-index: 100;
            white-space: nowrap;
          }

          .enter-site-button:hover {
            transform: translateX(-50%) scale(1.05);
          }
        }
      `}</style>

    </div>
  );
}
